const XERO_ACCT = 435
const XERO_HEADER = ",*ContactName,,EmailAddress,POAddressLine1,POAddressLine2,POAddressLine3,POAddressLine4,POCity,PORegion,POPostalCode,POCountry,*InvoiceNumber,*InvoiceDate,*DueDate,InventoryItemCode,Description,*Quantity,*UnitAmount,*AccountCode,*TaxType,TrackingName1,TrackingOption1,TrackingName2,TrackingOption2,Currency";

function csvify(val) {
  var result = val.replace(/"/g, '""');
  if (result.search(/("|,|\n)/g) >= 0) {
      result = '"' + result + '"';
  }
  return result;
}

function processRow(bill, strftime) {
  var starts_at = new Date(Date.parse(bill.starts_at));
  var ends_at = new Date(Date.parse(bill.ends_at));
  var invoice_desc = strftime(starts_at, 'MMMM yyyy') + ' Storage Bill'
  return  `"${invoice_desc}","${bill.account_name}","${bill.account_name} ${invoice_desc}",`+
          `,,,,,,,,,`+
          `${bill.account_name} ${invoice_desc}",`+
          `${strftime(starts_at, "M/d/yyyy")},`+
          `${strftime(ends_at, "M/d/yyyy")},`+
          `,`+
          `"${bill.account_name} ${invoice_desc}",`+
          `1,`+
          `$${bill.total_charge},`+
          `${XERO_ACCT},`+
          `Tax Exempt,`+
          `,,,,`+
          `${bill.stripe_charge_id}` + '\n';
}

export function createCSV(bills, $filter) {
  function strftime(d, f) {
    var localDate = new Date(d);
    var localTime = localDate.getTime();
    var localOffset = localDate.getTimezoneOffset() * 60000;
    return $filter('date')(new Date(localTime + localOffset), f);
  }

  var csvFile = XERO_HEADER + '\n';
  for (var i = 0; i < bills.length; i++) {
      csvFile += processRow(bills[i], strftime);
  }

  return csvFile;
}

export function forceDownload(csvFile) {
  var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
  var link = document.createElement("a");
  var url = URL.createObjectURL(blob);
  link.setAttribute("href", url);
  link.setAttribute("download", "storage_bills_export.csv");
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}



// WEBPACK FOOTER //
// ./views/storage_bills/create_csv.js